import Cookies from "js-cookie";

/**
 * Helper for parsing the cookie for autologin data (in app authentication).
 *
 * Copyright (C) 2020 Noom Inc.
 * Author: Sumin
 */

const IN_APP_COOKIE = "autologin_data";
const ACCESS_CODE = "accessCode";
const ACCESS_TOKEN = "accessToken";

const getAuthCookie = () => {
  const cookie = Cookies.get(IN_APP_COOKIE);
  if (cookie) {
    const parsedCookieDict = JSON.parse(cookie);
    if (ACCESS_TOKEN in parsedCookieDict && ACCESS_CODE in parsedCookieDict) {
      return parsedCookieDict;
    }
  }
  return null;
};

export const getAccessToken = () => {
  const authCookie = getAuthCookie();
  if (authCookie && ACCESS_TOKEN in authCookie) {
    return authCookie[ACCESS_TOKEN];
  }
  return null;
};

export default getAuthCookie;
